import React from 'react'
import styled from 'styled-components'
import { rem } from 'polished'
import { Box, Flex } from 'rebass'
import { Heading } from 'rebass'
import { media, InlineStyleReset, Container } from '../../../utils/style'
import buildImageUrl from '../../../../lib/media-url-maker'

export const Author = styled(Flex)`
  font-size: 15px;
  position: absolute;
  left: 0;
  bottom: ${rem(-34)};
  ${media.MediumScreenUp`
    bottom: ${rem(-84)};
  `};
  svg {
    margin-right: 13px;
    margin-bottom: -2px;
    opacity: 0.5;
  }
`

export const SubTitle = styled(Heading)`
  color: ${(props) => props.theme.colors.white_op65};
`

export const Title = styled(Heading)`
  a {
    color: white !important;
    text-decoration: none !important;
    position: relative;
    border-bottom: 2px solid white;
    &:hover {
      transition: 0.6s ${(props) => props.theme.ease.ease_out_expo};
      text-decoration: none !important;
      border-bottom: 2px solid rgba(255, 255, 255, 0.2);
    }
  }
`

export const Make = styled(({ theme, dark, ...rest }) => <Heading {...rest} />)`
  letter-spacing: 0.15em !important;
  color: ${(props) =>
    props.dark ? props.theme.colors.blue : props.theme.colors.white};
`

export const VehicleModelHeader = styled(
  ({ theme, dark, deep, light, ...rest }) => <Box {...rest} />
)`
  min-height: 300px;
  position: relative;
  overflow: hidden;
  height: auto;
  text-align: center;
  &::before {
    content: '';
    position: absolute;
    z-index: 0;
    top: 0;
    left: 0;
    right: 0;
    ${(props) => (props.deep ? 'height: 100%;' : 'height: 25vh;')}
    ${media.MediumScreenUp`
    ${(props) => (props.deep ? 'height: 75vh;' : 'height: 35vh;')}
    `}
    ${media.LargeScreenUp`
    height: ${(props) => (props.deep ? '65%' : '45%')};
    `}
    width: 100%;
    background-image: url(${(props) => buildImageUrl({ resource: props.bg })});
    background-size: cover;
    background-repeat: no-repeat;
    background-position: top center;
    transition: transform 12.8s ${(props) => props.theme.ease.ease_out_circ};
  }

  ${media.MediumScreenUp`
    padding-bottom: 5vh;
    padding-top: 10vh;
    min-height: 600px;
  `}

  &:hover::before {
    ${media.LargeScreenUp`
    transform: scale(1) translateZ(0);
    `}
  }

  &::after {
    content: '';
    display: block;
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 60%;
    ${(props) => (props.deep ? 'height: 20vh;' : '')}
    ${media.MediumScreenUp`
    height: 0%;
    ${(props) => (props.deep ? 'height: 30vh;' : '')}
    `}
    background-color: ${(props) =>
      !props.dark ? props.theme.colors.blue_light : props.theme.colors.blue};
    ${(props) => (props.light ? 'background-color: white;' : '')}
  }

  background-color: ${(props) =>
    !props.dark ? props.theme.colors.blue_light : props.theme.colors.blue};
  ${(props) => (props.light ? 'background-color: white;' : '')}
  &:hover a {
    color: ${(props) => props.theme.colors.blue};
  }
`

VehicleModelHeader.displayName = 'VehicleModelHeader'

export const VehicleModelHeaderSummary = styled(({ compact, ...rest }) => (
  <Box {...rest} />
))`
  z-index: 1;
  position: relative;
  color: white;
  max-width: ${(props) => props.theme.content.max.width};
  margin: 0 auto;
  a {
    color: white;
    text-decoration: none;
  }
  img {
    ${(props) => (props.compact ? 'margin-bottom: 0;' : '')}
  }
`

export const Summary = styled(({ theme, dark, ...rest }) => (
  <Container {...rest} />
))`
  line-height: 1.5;
  color: ${(props) =>
    !props.dark ? props.theme.colors.grey : props.theme.colors.white};
  > div * {
    ${InlineStyleReset}
  }
`

export const Callout = styled(({ ...rest }) => <a {...rest} />)`
  position: absolute;
  right: 200px;
`
